import React, { useState } from 'react';
import { Button, Flex, Space, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowRightOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons';
import UploadPolygraphyProductModal from '../../../modals/marketing/UploadPolygraphyProductModal';

export default function CustomPolygraphyProducts({ data, onProductSaved, className }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Marketing:Polygraphy:CustomPolygraphyProducts' });

  const [showProductModal, setShowProductModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const toggleProductModal = (product = null) => {
    setSelectedProduct(product);
    setShowProductModal((current) => !current);
  };

  return (
    <div className={className}>
      <Flex justify="space-between">
        <h6 className="underline">{t('title')}</h6>
        <Button type="primary" icon={<UploadOutlined />} onClick={() => toggleProductModal()}>
          {t('buttons.upload_product')}
        </Button>
      </Flex>
      <Table
        columns={[
          { title: 'ID', dataIndex: 'id' },
          { title: t('fields.name'), dataIndex: 'name' },
          { title: t('fields.format'), dataIndex: 'format' },
          {
            render: (item) => (
              <Space size="small">
                <Button type="link" icon={<ArrowRightOutlined />} onClick={() => window.open(item.file_url, '_blank')}>
                  {t('buttons.preview')}
                </Button>
                <Button type="link" icon={<EditOutlined />} onClick={() => toggleProductModal(item)}>
                  {t('buttons.edit')}
                </Button>
              </Space>
            ),
          },
        ]}
        dataSource={data}
        pagination={false}
      />
      {showProductModal && (
        <UploadPolygraphyProductModal
          product={selectedProduct}
          onClose={() => toggleProductModal()}
          onSuccess={onProductSaved}
        />
      )}
    </div>
  );
}
